module.exports = __webpack_public_path__ + "img/kasir.1afbe3fd.svg";